<template>
  <div class="news-detail-page">
    <div class="news-hero">
      <img src="@/assets/images/新闻背景.jpg" alt="头图" />
      <div class="hero-text">
        <h1>品牌新闻<span class="en-title"> / NEWS CENTER</span></h1>
      </div>
    </div>

    <div class="news-detail-content">
      <h2>{{ pageTitle }}</h2>
      <p class="meta">2026-08-07 ｜ 👁 2154{{ $t('news.look') }}</p>

      <div v-if="isZh">
        <img src="@/assets/images/Thirdstoreopen/1.jpg" alt="CABBEEN Mid Valley 开幕现场" />
        <p>2026年8月7日，潮流男装品牌 CABBEEN 卡宾 于马来西亚吉隆坡谷中城美佳广场（Mid Valley Megamall）正式开设马来西亚第三家门店，进一步拓展品牌在马来西亚市场的布局。</p>
        <p>与此同时，CABBEEN 卡宾旗下潮流子品牌 2AM 也首次登陆马来西亚，为本地消费者带来更多元的潮流男装选择，进一步丰富品牌在年轻时尚消费市场的产品布局。</p>
        <img src="@/assets/images/Thirdstoreopen/2.jpg" alt="CABBEEN Mid Valley 开幕嘉宾" />
        <p>新店位于 Mid Valley Megamall F-037。开幕当天，歌手兼演员车志立（车子）、演员／歌手 Faye 安映霏、知名电台主持人 DJ 盈盈、唱作歌手 Jaden Chen、艺人兼时尚 KOL Daryl、电视主持人及演员 Loh 罗辰昱、KOL Cado 科豆、演员 Daniel Fong、歌手 Lamzit 林泽、大马先生 Ewin Loke、大马先生洪伟扬、Mr Asia Champion 2025 Edward Chung 及艺人 Kelvin 李陞等多位本地艺人、KOL及嘉宾出席支持，共同见证 CABBEEN 卡宾新店启幕。</p>
        <img src="@/assets/images/Thirdstoreopen/3.jpg" alt="CABBEEN Mid Valley 开幕合影" />
        <p>活动当天，多位嘉宾身穿 CABBEEN 卡宾最新系列亮相，以不同造型诠释品牌融合潮流元素与现代男装设计的风格特色，展现 CABBEEN 多元而鲜明的时尚表达。</p>
        <p class="section-title">音乐表演共庆新店启幕</p>
        <p>开幕活动特别安排现场音乐表演，为活动注入更多活力。凭借热门歌曲《打火机》受到关注的歌手 Penny，以及马来西亚华裔马来语说唱歌手 Francis Roman 分别带来精彩演出，其中 Francis Roman 更现场演绎马来版《大展鸿图》，与现场嘉宾及消费者共同庆祝 CABBEEN 卡宾新店开幕。</p>
        <p>此次 Mid Valley 新店开幕，不仅标志着 CABBEEN 卡宾在马来西亚市场门店布局的进一步拓展，也代表品牌持续深化本地市场运营，与马来西亚消费者建立更紧密的时尚连接。</p>
        <p class="section-title">支持大马原创音乐发展</p>
        <img src="@/assets/images/Thirdstoreopen/4.jpg" alt="Music Boleh 活动现场" />
        <p>除了时尚领域，CABBEEN 卡宾也积极参与马来西亚本地创意文化交流，并担任 Music Boleh 荣誉赞助，支持大马原创音乐发展，鼓励更多本地音乐创作者持续创作。</p>
        <p>品牌希望透过结合时尚与音乐，与本地年轻创意社群建立更多交流机会。</p>
        <p class="section-title">CABBEEN Mid Valley 门店信息</p>
        <p class="store-info">📍 Mid Valley Megamall, F-037</p>
        <p class="store-info">Kuala Lumpur, Malaysia</p>
        <p class="store-info">欢迎莅临 CABBEEN Mid Valley，探索最新男装系列及 2AM 潮流服饰。</p>
      </div>

      <div v-else>
        <img src="@/assets/images/Thirdstoreopen/1.jpg" alt="CABBEEN Mid Valley Opening" />
        <p>7 August 2026, Kuala Lumpur, Malaysia — Contemporary menswear brand CABBEEN has officially opened its third store in Malaysia at Mid Valley Megamall, marking another milestone in the brand’s continued expansion and presence in the Malaysian market.</p>
        <p>At the same time, CABBEEN fashion sub-brand 2AM has made its debut in Malaysia, offering local consumers a broader selection of contemporary and trend-driven menswear while further expanding CABBEEN’s fashion portfolio for the younger generation.</p>
        <img src="@/assets/images/Thirdstoreopen/2.jpg" alt="CABBEEN Mid Valley Opening Guests" />
        <p>Located at F-037, Mid Valley Megamall, the new store welcomed a distinguished line-up of local celebrities, artists, media personalities and KOLs for its opening celebration. Guests included singer and actor Che Ta Li (Che Zi), actress and singer Faye An, renowned radio personality DJ Ying Ying, singer-songwriter Jaden Chen, entertainer and fashion KOL Daryl, television host and actor Loh Lo Chen Yu, KOL Cado, actor Daniel Fong, singer Lamzit, Mr Malaysia Ewin Loke, Mr Malaysia Hong Wei Yang, Mr Asia Champion 2025 Edward Chung, and entertainer Kelvin Li, among others.</p>
        <img src="@/assets/images/Thirdstoreopen/3.jpg" alt="CABBEEN Mid Valley Opening Group Photo" />
        <p>Several of the invited guests appeared in the latest CABBEEN collections, showcasing their individual interpretations of the brand’s contemporary menswear aesthetic. Through diverse styling and silhouettes, the looks reflected CABBEEN’s distinctive approach to combining contemporary fashion with modern menswear design.</p>
        <p class="section-title">Music Performances Celebrate the Grand Opening</p>
        <p>The opening celebration was complemented by live musical performances, bringing together fashion, music and contemporary culture.</p>
        <p>Singer Penny, who gained widespread attention with her popular track Lighter, delivered a live performance, while Malaysian Chinese-Malay rapper Francis Roman also took the stage, performing a Malay-language rendition of Da Zhan Hong Tu. The performances added to the vibrant atmosphere as guests and customers came together to celebrate the opening of CABBEEN latest store.</p>
        <p class="section-title">Supporting Malaysia’s Local Music Scene</p>
        <img src="@/assets/images/Thirdstoreopen/4.jpg" alt="Music Boleh Event" />
        <p>Beyond fashion, CABBEEN continues to engage with Malaysia’s local creative community and support the development of homegrown music. The brand recently served as an Honorary Sponsor of Music Boleh, demonstrating its support for Malaysian original music and local music creators.</p>
        <p>Through collaborations across fashion and music, CABBEEN seeks to foster stronger connections with Malaysia’s creative community while exploring new possibilities at the intersection of contemporary fashion, music and youth culture.</p>
        <p>The opening of the Mid Valley store marks another step in CABBEEN’s ongoing development in Malaysia, reflecting the brand’s continued commitment to growing its local presence and connecting with the country’s younger consumers and creative communities.</p>
        <p class="section-title">CABBEEN Mid Valley Store</p>
        <p class="store-info">Mid Valley Megamall</p>
        <p class="store-info">F-037, Kuala Lumpur, Malaysia</p>
        <p class="store-info">Discover the latest CABBEEN menswear collections and explore the 2AM fashion collection at the new CABBEEN Mid Valley store.</p>
      </div>

      <div class="back">
        <router-link to="/news" class="back-button">
          <span class="arrow">←</span> 返回 / return
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'Thirdstoreopen',
  setup() {
    const { locale } = useI18n()
    const pageTitle = computed(() => (
      locale.value === 'zh'
        ? 'CABBEEN卡宾马来西亚第三家门店正式开幕子品牌2AM首次登陆大马'
        : 'CABBEEN Malaysia Opens Third Store in Malaysia, Marking the Debut of Sub-Brand 2AM'
    ))
    const isZh = computed(() => locale.value === 'zh')
    return { pageTitle, isZh }
  },
}
</script>

<style scoped>
.news-detail-page {
  background: black;
  color: white;
  padding-bottom: 60px;
}

/* hero部分样式 */
.news-hero {
  position: relative;
  height: 230px;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}
.news-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
.hero-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
}
.hero-text h1 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  display: inline-block;
}
.en-title {
  display: inline;
  font-size: 20px;
  font-weight: normal;
  margin-left: 8px;
  letter-spacing: 0.5px;
  color: #ffb100;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.news-detail-content {
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
}
.news-detail-content h2 {
  color: #ffb100;
  font-size: 26px;
  margin-bottom: 40px;
  text-align: center;
  padding: 0 20px;
}
.news-detail-content .meta {
  font-size: 13px;
  color: #aaa;
  margin-bottom: 20px;
  text-align: center;
}
.news-detail-content p {
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: justify;
  text-indent: 2em;
  font-size: 16px;
}
.news-detail-content .section-title {
  color: #ffb100;
  font-weight: bold;
  text-align: center;
  text-indent: 0;
  margin-top: 28px;
  margin-bottom: 16px;
}
.news-detail-content .store-info {
  text-indent: 0;
  text-align: center;
}
.news-detail-content img {
  width: 100%;
  margin: 20px 0;
  border-radius: 8px;
  display: block;
}
.back {
  margin-top: 40px;
  text-align: center;
}

.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  background-color: #000;
  color: #ffb100;
  border: 1px solid #ffb100;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 120px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.back-button:hover {
  background-color: #ffb100;
  color: #000;
  border-color: #000;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 179, 0, 0.2);
}

.back-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(255, 179, 0, 0.2);
}

.arrow {
  margin-right: 8px;
  font-size: 18px;
}

@media (max-width: 768px) {
  .news-hero {
    height: 180px;
  }
  .hero-text h1 {
    font-size: 18px;
  }
  .news-detail-content {
    max-width: 100%;
    margin: 20px 10px;
    padding: 0 10px;
  }
  .news-detail-content h2 {
    font-size: 22px;
  }
  .news-detail-content .meta {
    font-size: 12px;
  }
  .news-detail-content p {
    font-size: 14px;
  }
  .news-detail-content img {
    margin: 10px 0;
  }
  .back-button {
    padding: 8px 18px;
    font-size: 14px;
  }
}
</style>
